module.exports = __webpack_public_path__ + "images/category_lp/watch/bg-text_5ab33e1323893fc7a7915777961d3f4a.png";